/** Public Contact Us / Terms details — same for every retail affiliate (MITO.money). */
export const MITO_SUPPORT_EMAIL = "support@mito.money";

export const MITO_PUBLIC_CONTACT = {
  legalLine: "Mito.Money C/O Funtech Global Communications Ltd",
  addressLine1: "Devonshire House",
  addressLine2: "Manor Way",
  addressLine3: "Borehamwood",
  addressCity: "Hertfordshire",
  addressPostCode: "WD6 1QQ",
  whatsapp: "+44 20 8731 4574",
  telephone: "+44 7535 838208",
} as const;

export const MITO_PUBLIC_POSTAL_LINE =
  "Mito.Money C/O Funtech Global Communications Ltd, Devonshire House, Manor way, Borehamwood, Hertfordshire, WD6 1QQ.";

export const MITO_POWERED_BY = "powered by mito.money";

export const PAYMENT_METHODS = {
  BANKPAYMENT: "BANKPAYMENT",
  TUNACCOUNT: "TUNACCOUNT",
  CARDCHECKOUT: "CARDCHECKOUT",
  CHECKOUTAPPLEPAY: "CHECKOUTAPPLEPAY",
  CARD: "CARD",
  CHECKOUTGOOGLEPAY: "CHECKOUTGOOGLEPAY",
  PAYBYBANK: "PAYBYBANK",
  PLAID: "PLAID",
  NOKRIN: "NOKRIN",
  INTERSWITCHCARD: "INTERSWITCHCARD",
};

export const PHONE_REG_EXP = /^[1-9]\d{1}[0-9]{2,15}$/;

export const PASSWORD_REG_EXP =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;

export const NO_SPECIAL_CHAR_REG_EXP = /^(\d|\w)+$/g;
export const CHAR_REG_EXP = /^[a-zA-Z ]*$/gm; // /^[A-Za-z]+$/gm;
export const SPACE_ALLOWED_NOT_SPECIAL_CHAR_REG_EXP = /^[A-Za-z0-9 ]+$/gm;

export const NICK_NAME_REG_EXP = /^[a-zA-Z0-9]*^\S*$/;
export const NAME_REG_EXP = /^[a-zA-Z\u00C0-\u017F\s.'-]*$/;
export const NAME_REPLACE_REG_EXP = /[^a-zA-Z\u00C0-\u017F\s.'-]/g;

export const CITY_REG_EXP =
  // eslint-disable-next-line no-useless-escape
  /^[a-zA-Z\u0080-\u024F]+(?:([\ \-\']|(\.\ ))[a-zA-Z\u0080-\u024F]+)*$/;

export const SERVICES = {
  MONEYTRANSFER: "MONEYTRANSFER",
  MOBILETOPUP: "MOBILETOPUP",
  BILLPAYMENT: "BILLPAYMENT",
};

export const TRANSACTION_STATUSES = {
  COMPSUCCESS: "COMPSUCCESS",
  COMPFAILED: "COMPFAILED",
  AWAITINGPAYMENT: "AWAITINGPAYMENT",
  TIMEOUT: "TIMEOUT",
  SCHEDULESUCCESS: "SCHEDULESUCCESS",
  INREVIEW: "INREVIEW",
  AWAITINGPROCESSING: "AWAITINGPROCESSING",
  READYTOPROCESS: "READYTOPROCESS",
  INPROGRESS: "INPROGRESS",
};

export const DAYS = [
  {
    id: 0,
    label: "Sunday",
    value: "SUNDAY",
  },
  {
    id: 1,
    label: "Monday",
    value: "MONDAY",
  },
  {
    id: 2,
    label: "Tuesday",
    value: "TUESDAY",
  },
  {
    id: 3,
    label: "Wednesday",
    value: "WEDNESDAY",
  },
  {
    id: 4,
    label: "Thursday",
    value: "THURSDAY",
  },
  {
    id: 5,
    label: "Friday",
    value: "FRIDAY",
  },
  {
    id: 6,
    label: "Saturday",
    value: "SATURDAY",
  },
  {
    id: -1,
    label: "Any",
    value: "ANY",
  },
];
